// multi-language-spellcheck.directive.ts
import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'input[pInputText], textarea[pInputText], p-inputText input, p-textarea textarea',
  standalone: true
})
export class MultiLanguageSpellcheckDirective implements AfterViewInit {

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    const input = element.tagName === 'INPUT' || element.tagName === 'TEXTAREA'
      ? element : element.querySelector('input, textarea');

    if (input) {
      input.setAttribute('spellcheck', 'true');
      input.setAttribute('lang', 'es');
    }
  }
}